import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_Aside = _resolveComponent("Aside")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      (_ctx.isOpenMenu)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "overlay",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.isOpenMenu = false), ["self"]))
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_header, { class: "header" }, {
        default: _withCtx(() => [
          _createVNode(_component_Header, {
            onOnHamburgerClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpenMenu = true))
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_aside, {
            class: _normalizeClass(["sidebar", {'open': _ctx.isOpenMenu}])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Aside, {
                onOnMenuItemSelect: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpenMenu = false))
              })
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_el_main, { class: "page-content has-sidebar" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view, null, {
                default: _withCtx(({ Component }) => [
                  (_openBlock(), _createBlock(_KeepAlive, null, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                  ], 1024))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}